import React from "react";
import {
  FlatButton,
  RaisedButton,
  Toggle,
  RadioButtonGroup,
  RadioButton
} from "material-ui";
import moment from "moment";

import { capitalize } from "../../util";

import PassActions from "../../actions/PassActions";
import PassStore from "../../stores/PassStore";

import BaseOverlay from "./overlays/base.jsx";

import LinkLike from "./link-like.jsx";
import WorkingIndicator from "./working-indicator.jsx";
import DatePicker from "./datepicker.jsx";

class PassSubscriptionModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dirty: false,
      values: {},
      editingRenewalDate: false
    };

    this.onChangeValue = this.onChangeValue.bind(this);
    this.cancel = this.cancel.bind(this);
    this.submit = this.submit.bind(this);
    this.cancelSubscription = this.cancelSubscription.bind(this);
  }

  getStyles() {
    return {
      actions: {
        marginTop: 15
      },
      dialogTitle: {
        borderBottom: "none"
      },
      dialogActionsContainer: {
        borderTop: "none"
      },
      debug: {
        fontSize: "0.5em",
        fontFamily: "monospace",
        wordWrap: "break-word",
        lineHeight: 1,
        marginTop: "2em",
        marginBottom: "-2em",
        height: 30,
        overflow: "scroll"
      }
    };
  }

  onChangeValue(id, value, cb) {
    this.state.dirty = true;
    this.state.values[id] = value;
    this.setState(this.state, cb);
  }

  cancel() {
    this.props.requestClose();
  }

  submit() {
    if (this.props.onSubmit) {
      this.props.onSubmit(this.state.values);
      return;
    }

    this.setState({ editingRenewalDate: false });
    PassActions.editPassSubscription(
      this.props.passSubscription.id,
      this.state.values
    );

    // Don't close - show updates reflected
    // this.props.requestClose();
  }

  cancelSubscription() {
    if (
      window.confirm(
        "Are you sure? Cancellation is immediate and ends all pass privileges."
      )
    ) {
      this.setState(
        {
          values: {
            cancel: true
          }
        },
        () => {
          this.submit();
        }
      );
    }
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.passSubscription) {
      this.setState({
        dirty: false,
        values: {
          silent: true,
          should_autorenew: newProps.passSubscription.should_autorenew,
          renewal_date: newProps.passSubscription.renewal_date
        }
      });
    }
  }

  render() {
    let styles = this.getStyles(),
      { passSubscription } = this.props;

    return (
      <BaseOverlay
        title={"Manage subscription"}
        titleStyle={styles.dialogTitle}
        actionsContainerStyle={styles.dialogActionsContainer}
        useMuiDefaultStyle={true}
        openImmediately={true}
        actions={[
          <FlatButton label={"Close"} onTouchTap={this.cancel} />,
          <FlatButton
            disabled={!this.state.dirty}
            primary={true}
            label={"Update subscription"}
            onTouchTap={this.submit}
          />
        ]}
        modal={true}
        open={true}
        onRequestClose={this.cancel}
      >
        {passSubscription && !PassStore.getState().isEditing ? (
          <div>
            <div>
              Customer:{" "}
              <strong>
                {passSubscription.person.name || passSubscription.person.email}
              </strong>
            </div>
            <div>
              Subscription:{" "}
              <strong>
                {passSubscription.quantity}x {passSubscription.pass_bucket.name}
              </strong>
            </div>
            <div>
              Status: <strong>{capitalize(passSubscription.status)}</strong>
            </div>

            {passSubscription.status === "active" ? (
              <div style={{ marginTop: "1em" }}>
                <div>
                  {this.state.values.should_autorenew
                    ? "Renewal"
                    : "Expiration"}{" "}
                  date:{" "}
                  <strong>
                    {moment(this.state.values.renewal_date).format("LL")}
                  </strong>
                </div>
                <Toggle
                  toggled={this.state.values.should_autorenew}
                  onToggle={(e, checked) => {
                    this.onChangeValue("should_autorenew", checked);
                  }}
                  label={
                    this.state.values.should_autorenew
                      ? "Autorenewal enabled"
                      : "Autorenewal disabled"
                  }
                  style={{ width: "auto" }}
                  labelStyle={{ color: "auto" }}
                  labelPosition="right"
                />
              </div>
            ) : (
              <div style={{ marginTop: "1em" }}>
                <div>
                  Scheduled renewal date:{" "}
                  <strong>
                    <del>
                      {moment(passSubscription.renewal_date).format("LL")}
                    </del>
                  </strong>
                </div>
                <div>
                  {passSubscription.status === "canceled"
                    ? "Cancellation"
                    : "Expiration"}{" "}
                  date:{" "}
                  <strong>
                    {moment(
                      passSubscription.expired_date ||
                        passSubscription.renewal_date
                    ).format("LL")}
                  </strong>
                </div>
              </div>
            )}

            <div style={{ marginTop: "1em" }}>
              {passSubscription.status !== "active" ? (
                <div>
                  This subscription has{" "}
                  {passSubscription.status === "canceled" ? (
                    <span>
                      been <strong>canceled</strong>
                    </span>
                  ) : (
                    <strong>expired</strong>
                  )}
                  . You can
                  {this.state.reopeningSubscription ? (
                    <span>
                      {" "}
                      use the below options to reopen the subscription and then
                      click "Update Subscription" to submit, or{" "}
                      <LinkLike
                        onTouchTap={() =>
                          this.setState({ reopeningSubscription: false })
                        }
                      >
                        undo changes
                      </LinkLike>
                    </span>
                  ) : (
                    ":"
                  )}
                  {!this.state.reopeningSubscription ? (
                    <div style={{ marginTop: "0.5em" }}>
                      <RaisedButton
                        label="Reopen subscription..."
                        primary={true}
                        onTouchTap={() => {
                          this.setState({ reopeningSubscription: true }, () => {
                            this.onChangeValue(
                              "new_renewal_charge_now",
                              true,
                              () => {
                                this.onChangeValue(
                                  "new_renewal_date",
                                  moment()
                                    .add(
                                      passSubscription.pass_bucket
                                        .recurrence_count || 1,
                                      passSubscription.pass_bucket
                                        .recurrence_interval || "year"
                                    )
                                    .toISOString()
                                );
                              }
                            );
                          });
                        }}
                      />
                    </div>
                  ) : (
                    <div>
                      <div>
                        <DatePicker
                          style={{ display: "inline-block" }}
                          value={this.state.values.new_renewal_date}
                          label={"Next renewal date"}
                          returnFormat={null} // date object
                          onChange={v =>
                            this.onChangeValue(
                              "new_renewal_date",
                              v.toISOString()
                            )
                          }
                          errorText={
                            moment().isAfter(
                              moment(this.state.values.new_renewal_date)
                            ) && "Next renewal date must be in the future"
                          }
                        />
                      </div>
                      <RadioButtonGroup
                        style={{ marginTop: "0.5em" }}
                        name="new-charge"
                        valueSelected={this.state.values.new_renewal_charge_now}
                        onChange={(e, value) =>
                          this.onChangeValue("new_renewal_charge_now", value)
                        }
                      >
                        <RadioButton
                          value={true}
                          label={`Charge customer immediately, then charge again on above renewal date (${moment(
                            this.state.values.new_renewal_date
                          ).format("LL")})`}
                        />
                        <RadioButton
                          value={false}
                          label={`Do not charge the customer until above renewal date (${moment(
                            this.state.values.new_renewal_date
                          ).format("LL")})`}
                        />
                      </RadioButtonGroup>
                    </div>
                  )}
                  {/*<ul>
                    <li><LinkLike>Reopen subscription with a new renewal date of today, {moment().format('LL')}</LinkLike> (will charge <i>immediately</i>, then charge again one payment cycle later, on {moment().add(passSubscription.stripe_subscription.plan.interval_count, passSubscription.stripe_subscription.plan.interval).format('LL')})</li>
                    <li><LinkLike>Reopen with original renewal date, {moment(passSubscription.renewal_date).format('LL')}</LinkLike> (will charge <i>{moment(passSubscription.renewal_date).isAfter(moment()) ? `${moment(passSubscription.renewal_date).format('LL')}` : 'immediately for missed renewal'}</i>, then charge again one payment cycle later, on {moment(passSubscription.renewal_date).add(passSubscription.stripe_subscription.plan.interval_count, passSubscription.stripe_subscription.plan.interval).format('LL')})</li>
                    <li><LinkLike>Reopen with a custom renewal date</LinkLike> (will not charge until this date; can choose date after selecting)</li>
                  </ul>*/}
                </div>
              ) : (
                <div>
                  {this.state.editingRenewalDate ? (
                    <div>
                      <div>
                        Enter a new{" "}
                        {this.state.values.should_autorenew
                          ? "renewal"
                          : "expiration"}{" "}
                        date sometime in the future & click "Update
                        Subscription" to modify the subscription, or{" "}
                        <LinkLike
                          onTouchTap={() =>
                            this.setState({ editingRenewalDate: false }, () =>
                              this.onChangeValue(
                                "renewal_date",
                                passSubscription.renewal_date
                              )
                            )
                          }
                        >
                          undo changes
                        </LinkLike>
                      </div>
                      <DatePicker
                        style={{ display: "inline-block" }}
                        value={this.state.values.renewal_date}
                        label={"Renewal date"}
                        returnFormat={null} // date object
                        onChange={v =>
                          this.onChangeValue("renewal_date", v.toISOString())
                        }
                        errorText={
                          moment().isAfter(
                            moment(this.state.values.renewal_date)
                          ) && "Renewal date must be in the future"
                        }
                      />
                    </div>
                  ) : (
                    <div>
                      <div>
                        This subscription is currently active and will{" "}
                        {this.state.values.should_autorenew
                          ? "renew"
                          : "expire"}{" "}
                        {moment(passSubscription.renewal_date).fromNow()}.{" "}
                        <LinkLike
                          onTouchTap={() =>
                            this.setState({ editingRenewalDate: true })
                          }
                        >
                          Edit{" "}
                          {this.state.values.should_autorenew
                            ? "renewal"
                            : "expiration"}{" "}
                          date
                        </LinkLike>
                      </div>
                      <div style={{ marginTop: "1em", fontSize: "0.8em" }}>
                        You can also{" "}
                        <LinkLike onTouchTap={() => this.cancelSubscription()}>
                          immediately cancel this subscription
                        </LinkLike>
                        .{" "}
                        <small>
                          (All passes will stop working. No refund will be
                          issued.)
                        </small>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div style={styles.debug}>
              <strong>TROUBLESHOOTING INFORMATION:</strong>{" "}
              {JSON.stringify(passSubscription)}
            </div>
          </div>
        ) : (
          <WorkingIndicator centered />
        )}
      </BaseOverlay>
    );
  }
}

export default PassSubscriptionModal;



// WEBPACK FOOTER //
// ./src/app/components/partials/pass-subscription-modal.jsx